// extracted by mini-css-extract-plugin
export var withArrow = "styles-module--withArrow--UAji6";
export var arrow = "styles-module--arrow--kyfoJ";
export var arrowReverse = "styles-module--arrowReverse--GCG9W";
export var gradient = "styles-module--gradient--geVGE";
export var backAndForthRight = "styles-module--backAndForthRight--77QvM";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--m46vT";
export var animateBg = "styles-module--animateBg--3l47a";